import { compose, find, prop, map, toPairs } from 'ramda';

import { generateStaticRoutes } from './statics';

const staticPages = compose(
  map(([entryId, { name, path }]) => ({ name, path, entryId })),
  toPairs
);

const allPages = (pages) => [...pages, ...staticPages(generateStaticRoutes())];

const pageName = (findFn, pages) =>
  compose(prop('name'), findFn, allPages)(pages);

export const pageNameByType = (type, pages) =>
  pageName(
    find((page) => page.entryId === type),
    pages
  );
